export type MonetizedAvalesSearchResolution = {
  searchText?: string;
};

export const resolveMonetizedAvalesSearch = (
  searchText: string,
): MonetizedAvalesSearchResolution => {
  const trimmed = searchText.trim();
  if (!trimmed) {
    return {};
  }

  if (!/^[\d-]+$/.test(trimmed)) {
    return {};
  }

  const digitsOnly = trimmed.replace(/\D/g, '');
  if (!digitsOnly) {
    return {};
  }

  return { searchText: digitsOnly };
};
